"use client";

import { GTM } from "@/lib/analytics/analytics-index";
import { ShopFilters } from "@/lib/shop/shop-types";
import { ShopStore } from "@/state-management/stores/shop-store";
import { cloneDeep } from "lodash";
import { useEffect, useRef } from "react";

export function GTMShopFilterTracker({ children }: { children?: React.ReactNode }) {
    function cleanFilterValues(filterName: string, filterValue: string | string[]) {
        let cleanedValues = [] as string[];
        if (Array.isArray(filterValue)) {
            cleanedValues = filterValue.map((filter) => filter.toLowerCase());
        } else {
            cleanedValues = [filterValue];
        }
        return cleanedValues;
    }

    // hook to filter store
    const filters = ShopStore.use.filters();

    // track sent filters to prevent dupes
    const sentFilters = useRef<ShopFilters>({});

    // when filters change
    useEffect(() => {
        // push execution to next event loop to prevent dupes in react strict mode
        const timer = setTimeout(() => {
            const filterNames = Object.keys(filters).sort();

            filterNames.forEach((filterName) => {
                const filterValue = filters[filterName];
                if (!filterValue || filterValue.length === 0) return;

                // standardize names and values
                const cleanFilterName = filterName.toLowerCase();
                const cleanValues = cleanFilterValues(filterName, filterValue).sort();

                const prevCleanValues = cleanFilterValues(
                    filterName,
                    sentFilters.current[filterName] || []
                );

                // if new send event
                cleanValues.forEach((cleanValue) => {
                    if (!prevCleanValues.includes(cleanValue))
                        GTM.sendEvent({
                            event: "set_filter",
                            filter: cleanFilterName,
                            filter_value: cleanValue,
                            all_filters: filterNames.join("|"),
                            all_filter_values: cleanValues.join("|"),
                            all_filters_count: filterNames.length,
                            all_filter_values_count: cleanValues.length
                        });
                });
            });

            sentFilters.current = cloneDeep(filters);
        }, 0);

        return () => clearTimeout(timer);
    }, [filters]);

    return <div>{children}</div>;
}
